import { PathLike } from 'fs'
import { FileHandle } from 'fs/promises'
import { IGoogleAdConfig, ILazyLoadConfig } from '../sharedComponents/types'

// How long before a Kaltura ks actually expires we treat it as stale and log
// in again. Checking the bare expiry lets a ks with seconds left through, which
// then fails the very request it was fetched for. Shared by the server-side
// cache (utils/server/ks.ts) and the client-side refresh (OttOverlayProvider).
export const KS_EXPIRY_GRACE_SECONDS = 300

export const midBoxPositions = [11, 7, 3, 2]
export const taboolaPositionsGridVOD = (i: number) =>
  i === 1 || (i > 1 && (i - 1) % 5 === 0)

export interface ILiveSources {
  mobile: {
    provider: 'gmana' | 'kaltura'
    live_with_subs: string
    live_no_subs: string
  }
  desktop: {
    provider: 'gmana' | 'kaltura'
    live_with_subs: string
    live_no_subs: string
  }
  // Single stream for viewers outside Israel, on every platform and with or
  // without subtitles. Optional so a live.json without it keeps serving
  // everyone the Israel streams above.
  global?: {
    provider: 'gmana' | 'kaltura'
    live: string
  }
}

export interface IConfigFile {
  ros_interstitial: 'on' | 'off' | string
  recently_aired_json_path: PathLike | FileHandle | null | string
  short_videos_client?: null | string
  short_videos_server?: null | string
  video_rail_map_path: PathLike | FileHandle | null | string
  live_title?: string
  live_h_title?: string
  live_description?: string
  siteName?: string
  logo?: string
  bb_ads_time_interval?: number
  googleAds?: {
    enableSingleRequest?: boolean
    enableLazyLoad?: boolean
    lazyLoadConfig?: ILazyLoadConfig
  }
  player: {
    autoplay: {
      mobile: boolean
      desktop: boolean
      app: boolean
    }
  }
}

export interface IOttPageMeta {
  type: number
  externalId: string
  assetId: number
  seasonNumber: number
  title: string
  description: string
  ogImage: string
  ref: string
  startDate: number
  endDate: number
  seo: {
    title: string
    description: string
  }
}

export const liveSourcesDefault: ILiveSources = {
  mobile: {
    provider: 'gmana',
    live_with_subs:
      'https://reshet.g-mana.live/media/6f10d1da-0803-48d9-9272-57a811958974/mainManifest.m3u8',
    live_no_subs:
      'https://reshet.g-mana.live/media/cdefce3a-14ec-46cc-a147-1275c4a8b9ed/mainManifest.m3u8',
  },
  desktop: {
    provider: 'gmana',
    live_with_subs:
      'https://reshet.g-mana.live/media/4607e158-e4d4-4e18-9160-3dc3ea9bc677/mainManifest.m3u8',
    live_no_subs:
      'https://reshet.g-mana.live/media/87f59c77-03f6-4bad-a648-897e095e7360/mainManifest.m3u8',
  },
}

export const defaultGoogleAdsLazyLoadConfig: ILazyLoadConfig = {
  fetchMarginPercent: 500,
  mobileScaling: 2,
  renderMarginPercent: 200,
}
export const defaultGoogleAdsConfig: IGoogleAdConfig = {
  enableServices: true,
  enableSingleRequest: false,
  enableLazyLoad: true,
  lazyLoadConfig: defaultGoogleAdsLazyLoadConfig,
}
